// ─── KPI Data by Zone ───

const kpiDataByZone = {
  'finishing-zone': [
    {
      id: 'work-orders',
      title: 'Work Orders',
      value: '75',
      change: '+3%',
      changeType: 'negative',
      subtitle: 'vs last month',
      icon: 'wrench',
      sparkline: [30, 45, 35, 50, 40, 55, 65, 50, 70, 60, 75],
      sparkColor: '#399432',
    },
    {
      id: 'asset-failures',
      title: 'Assets at risk',
      value: '12',
      change: '-10%',
      changeType: 'positive',
      subtitle: 'vs last month',
      icon: 'warning',
      sparkline: [5, 8, 4, 10, 6, 9, 7, 11, 8, 10, 12],
      sparkColor: '#F59E0B',
    },
    {
      id: 'avg-mttr',
      title: 'Average MTTR',
      value: '12 mins',
      change: '-15.5%',
      changeType: 'positive',
      subtitle: 'vs last month',
      icon: 'clock',
      sparkline: [8, 10, 7, 12, 9, 11, 10, 13, 9, 11, 12],
      sparkColor: '#399432',
    },
    {
      id: 'oee',
      title: 'Pending Requests',
      value: '04',
      change: '',
      changeType: 'positive',
      subtitle: '',
      icon: 'refresh',
      sparkline: null,
      sparkColor: '#399432',
    },
    {
      id: 'repair-costs',
      title: 'Service costs',
      value: '$328K',
      change: '+8.5%',
      changeType: 'negative',
      subtitle: 'vs last month',
      icon: 'trending',
      sparkline: [200, 220, 250, 230, 260, 280, 270, 300, 290, 310, 328],
      sparkColor: '#F59E0B',
    },
    {
      id: 'avg-rul',
      title: 'Average RUL',
      value: '~6.5 Years',
      change: null,
      changeType: null,
      subtitle: 'for all the assets in location',
      icon: 'timer',
      sparkline: null,
      sparkColor: null,
    },
  ],
  'assembly-zone': [
    {
      id: 'work-orders',
      title: 'Work Orders',
      value: '52',
      change: '+8.2%',
      changeType: 'positive',
      subtitle: 'vs last month',
      icon: 'wrench',
      sparkline: [25, 30, 28, 35, 32, 40, 38, 45, 42, 48, 52],
      sparkColor: '#399432',
    },
    {
      id: 'asset-failures',
      title: 'Assets at risk',
      value: '8',
      change: '-5.3%',
      changeType: 'positive',
      subtitle: 'vs last month',
      icon: 'warning',
      sparkline: [10, 9, 11, 8, 10, 7, 9, 8, 7, 9, 8],
      sparkColor: '#399432',
    },
    {
      id: 'avg-mttr',
      title: 'Average MTTR',
      value: '8 mins',
      change: '-12.0%',
      changeType: 'positive',
      subtitle: 'vs last month',
      icon: 'clock',
      sparkline: [12, 11, 10, 9, 10, 9, 8, 9, 8, 8, 8],
      sparkColor: '#399432',
    },
    {
      id: 'oee',
      title: 'Pending Requests',
      value: '04',
      change: '',
      changeType: 'positive',
      subtitle: '',
      icon: 'refresh',
      sparkline: null,
      sparkColor: '#399432',
    },
    {
      id: 'repair-costs',
      title: 'Service costs',
      value: '$215K',
      change: '-4.5%',
      changeType: 'positive',
      subtitle: 'vs last month',
      icon: 'trending',
      sparkline: [240, 235, 230, 228, 225, 222, 220, 218, 216, 215, 215],
      sparkColor: '#399432',
    },
    {
      id: 'avg-rul',
      title: 'Average RUL',
      value: '~5.1 Years',
      change: null,
      changeType: null,
      subtitle: 'for all the assets in location',
      icon: 'timer',
      sparkline: null,
      sparkColor: null,
    },
  ],
  'packaging-zone': [
    {
      id: 'work-orders',
      title: 'Work Orders',
      value: '34',
      change: '+22.1%',
      changeType: 'negative',
      subtitle: 'vs last month',
      icon: 'wrench',
      sparkline: [15, 18, 20, 22, 19, 24, 26, 28, 30, 32, 34],
      sparkColor: '#F59E0B',
    },
    {
      id: 'asset-failures',
      title: 'Assets at risk',
      value: '5',
      change: '+25.0%',
      changeType: 'negative',
      subtitle: 'vs last month',
      icon: 'warning',
      sparkline: [2, 3, 2, 4, 3, 3, 4, 4, 5, 4, 5],
      sparkColor: '#EF4444',
    },
    {
      id: 'avg-mttr',
      title: 'Average MTTR',
      value: '18 mins',
      change: '+6.8%',
      changeType: 'negative',
      subtitle: 'vs last month',
      icon: 'clock',
      sparkline: [14, 15, 14, 16, 15, 17, 16, 18, 17, 18, 18],
      sparkColor: '#EF4444',
    },
    {
      id: 'oee',
      title: 'Pending Requests',
      value: '04',
      change: '',
      changeType: 'positive',
      subtitle: '',
      icon: 'refresh',
      sparkline: null,
      sparkColor: '#399432',
    },
    {
      id: 'repair-costs',
      title: 'Service costs',
      value: '$182K',
      change: '+12.3%',
      changeType: 'negative',
      subtitle: 'vs last month',
      icon: 'trending',
      sparkline: [140, 148, 152, 155, 160, 162, 168, 172, 175, 180, 182],
      sparkColor: '#EF4444',
    },
    {
      id: 'avg-rul',
      title: 'Average RUL',
      value: '~7.2 Years',
      change: null,
      changeType: null,
      subtitle: 'for all the assets in location',
      icon: 'timer',
      sparkline: null,
      sparkColor: null,
    },
  ],
};

// ─── Service Costs by Zone ───

const serviceCostsDataByZone = {
  'finishing-zone': {
    total: '$328K',
    categories: [
      { name: 'Labor', unplanned: '$125.0K', planned: '$85.0K', change: 38, color: '#399432' },
      { name: 'Spare Parts', unplanned: '$89.0K', planned: '$59.0K', change: 27, color: '#F59E0B' },
      { name: 'Contractor Services', unplanned: '$65.0K', planned: '$25.0K', change: 20, color: '#3B82F6' },
      { name: 'Equipment Rental', unplanned: '$32.0K', planned: '$12.0K', change: 10, color: '#67E8F9' },
      { name: 'Other', unplanned: '$17.0K', planned: '$14.0K', change: 5, color: '#9CA3AF' },
    ],
  },
  'assembly-zone': {
    total: '$215K',
    categories: [
      { name: 'Labor', unplanned: '$72.0K', planned: '$55.0K', change: 33, color: '#399432' },
      { name: 'Spare Parts', unplanned: '$58.0K', planned: '$42.0K', change: 28, color: '#F59E0B' },
      { name: 'Contractor Services', unplanned: '$38.0K', planned: '$18.0K', change: 18, color: '#3B82F6' },
      { name: 'Equipment Rental', unplanned: '$25.0K', planned: '$10.0K', change: 12, color: '#67E8F9' },
      { name: 'Other', unplanned: '$12.0K', planned: '$9.0K', change: 9, color: '#9CA3AF' },
    ],
  },
  'packaging-zone': {
    total: '$182K',
    categories: [
      { name: 'Labor', unplanned: '$65.0K', planned: '$48.0K', change: 35, color: '#399432' },
      { name: 'Spare Parts', unplanned: '$42.0K', planned: '$30.0K', change: 24, color: '#F59E0B' },
      { name: 'Contractor Services', unplanned: '$35.0K', planned: '$22.0K', change: 19, color: '#3B82F6' },
      { name: 'Equipment Rental', unplanned: '$22.0K', planned: '$15.0K', change: 13, color: '#67E8F9' },
      { name: 'Other', unplanned: '$14.0K', planned: '$8.0K', change: 9, color: '#9CA3AF' },
    ],
  },
};

// ─── AI Insights by Zone ───

const aiInsightsByZone = {
  'finishing-zone': [
    {
      id: 1,
      title: 'Asset Bearing Failure Risk',
      severity: 'High',
      severityColor: '#EF4444',
      description:
        'Pump-A12 has encountered 3 failures in the last 1 year. Normal asset life is 5 years. Recommend proactive replacement',
      recommendation: 'Schedule bearing replacement within 2 weeks',
      asset: 'Pump-A12',
      expanded: true,
    },
    {
      id: 2,
      title: 'Predictive Maintenance Opportunity',
      severity: null,
      description:
        'Conveyor Belt B-07 shows increasing vibration patterns. Predictive model suggests 78% chance of failure within 30 days.',
      recommendation: 'Schedule inspection within 1 week',
      asset: 'Conveyor-B07',
      expanded: false,
    },
    {
      id: 3,
      title: 'Predictive Maintenance Opportunity',
      severity: null,
      description:
        'Motor M-15 temperature readings are trending upward. Historical data suggests potential overheating within 45 days.',
      recommendation: 'Monitor closely and plan maintenance',
      asset: 'Motor-M15',
      expanded: false,
    },
  ],
  'assembly-zone': [
    {
      id: 1,
      title: 'Robotic Arm Calibration Drift',
      severity: 'High',
      severityColor: '#EF4444',
      description:
        'Welding Robot W-22 calibration has drifted 0.8mm beyond tolerance. Assembly defect rate increased 12% this week.',
      recommendation: 'Recalibrate robot arm within 3 days',
      asset: 'Welding Robot W-22',
      expanded: true,
    },
    {
      id: 2,
      title: 'Torque Wrench Degradation',
      severity: 'Medium',
      severityColor: '#F59E0B',
      description:
        'Automated torque station T-05 showing inconsistent torque values. 15% variance detected in last 500 cycles.',
      recommendation: 'Replace torque sensor within 1 week',
      asset: 'Torque-T05',
      expanded: false,
    },
    {
      id: 3,
      title: 'Predictive Maintenance Opportunity',
      severity: null,
      description:
        'Assembly conveyor AC-03 belt tension decreasing gradually. Predictive model suggests replacement needed within 60 days.',
      recommendation: 'Order replacement belt and schedule downtime',
      asset: 'Conveyor-AC03',
      expanded: false,
    },
  ],
  'packaging-zone': [
    {
      id: 1,
      title: 'Sealing Unit Overheating',
      severity: 'High',
      severityColor: '#EF4444',
      description:
        'Heat sealer HS-08 running 15°C above normal operating temperature. Risk of seal quality failure and potential fire hazard.',
      recommendation: 'Shut down and inspect heating element immediately',
      asset: 'Heat Sealer HS-08',
      expanded: true,
    },
    {
      id: 2,
      title: 'Label Printer Alignment Issue',
      severity: 'Medium',
      severityColor: '#F59E0B',
      description:
        'Label printer LP-02 misalignment detected. 8% of labels placed outside tolerance in last batch.',
      recommendation: 'Realign print head within 2 days',
      asset: 'Printer-LP02',
      expanded: false,
    },
    {
      id: 3,
      title: 'Predictive Maintenance Opportunity',
      severity: null,
      description:
        'Palletizer P-01 hydraulic pressure showing gradual decline. Historical pattern suggests seal replacement needed within 30 days.',
      recommendation: 'Schedule hydraulic seal replacement',
      asset: 'Palletizer-P01',
      expanded: false,
    },
  ],
};

// ─── Exported Helpers ───

export const getDashboardDataByZone = (zoneId) => ({
  kpiData: kpiDataByZone[zoneId] || kpiDataByZone['finishing-zone'],
  serviceCostsData: serviceCostsDataByZone[zoneId] || serviceCostsDataByZone['finishing-zone'],
  aiInsights: aiInsightsByZone[zoneId] || aiInsightsByZone['finishing-zone'],
  workOrders: workOrdersByZone[zoneId] || workOrdersByZone['finishing-zone'],
  requests: requestsByZone[zoneId] || requestsByZone['finishing-zone'],
});

export const quickActions = [
  {
    id: 'qr-scan',
    title: 'QR Scan',
    description: 'Scan an asset using QR reader',
    icon: 'qr',
    color: '#37474F',
  },
  {
    id: 'nfc-tap',
    title: 'NFC Tap',
    description: 'Scan an asset using QR reader',
    icon: 'nfc',
    color: '#F4A261',
  },
  {
    id: 'manual-search',
    title: 'Manual Search',
    description: 'Scan an asset using QR reader',
    icon: 'search',
    color: '#2A9D8F',
  },
];

// ─── Assigned Assets by Zone ───

const assignedAssetsByZone = {
  'finishing-zone': [
    {
      id: 'asset-1',
      name: 'CNC Lathe',
      assetId: 'A231',
      model: 'RFS465465',
      make: 'CSB Industries',
      type: 'Pump',
      workOrderId: 'WO-1334',
      priority: 'High',
      status: 'Offline',
      statusLabel: 'Critical',
      location: {
        workspace: 'Workspace East',
        zone: 'Zone 48',
        area: 'Finishing Zone',
      },
      image: 'https://images.unsplash.com/photo-1565992441121-4367c2967103?w=800&q=80',
      healthScore: 52,
      alert: {
        type: 'error',
        message: 'Emergency maintenance recommended',
        confidence: '80% confidence',
      },
      rul: {
        label: 'RUL',
        value: '1 Year 6 Months',
      },
      workOrders: {
        label: 'Work Orders',
        value: 5,
      },
      nextService: {
        label: 'Next Service',
        value: '15 Mar 2026',
      },
      failureProbability: {
        value: '85%',
        timeframe: 'with in 7 days',
      },
      recommendedAction: {
        title: 'Emergency Maintenance',
        description: 'Replace bearing immediately to prevent failure',
        severity: 'critical',
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: '95 °C',
          normal: '20-60',
          unit: '°C',
          reportedTimestamp: 'Feb 19, 2026, 10:32 AM',
        },
        vibration: {
          label: 'Vibration',
          value: '6.5 mm/s',
          normal: '0-3',
          unit: 'mm/s',
          reportedTimestamp: 'Feb 19, 2026, 10:32 AM',
        },
        pressure: {
          label: 'Pressure',
          value: '2.8 bar',
          normal: '2.5-3.2',
          unit: 'bar',
          reportedTimestamp: 'Feb 19, 2026, 10:32 AM',
        },
      },
    },
    {
      id: 'asset-2',
      name: 'Hydraulic Pump',
      assetId: 'A232',
      model: 'HPX789456',
      make: 'Bosch Rexroth',
      type: 'Hydraulic System',
      workOrderId: '',
      priority: 'Moderate',
      status: 'Online',
      statusLabel: 'Warning',
      location: {
        workspace: 'Workspace East',
        zone: 'Zone 48',
        area: 'Finishing Zone',
      },
      image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80',
      healthScore: 68,
      alert: {
        type: 'warning',
        message: 'Estimated failure in 1 month',
        confidence: '90% confidence',
      },
      rul: {
        label: 'RUL',
        value: '2 Years 3 Months',
      },
      workOrders: {
        label: 'Work Orders',
        value: 2,
      },
      nextService: {
        label: 'Next Service',
        value: '12 Apr 2026',
      },
      failureProbability: {
        value: '45%',
        timeframe: 'with in 30 days',
      },
      recommendedAction: {
        title: 'Scheduled Maintenance',
        description: 'Schedule oil change and filter replacement within 2 weeks',
        severity: 'warning',
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: '68 °C',
          normal: '20-60',
          unit: '°C',
          reportedTimestamp: 'Feb 19, 2026, 10:28 AM',
        },
        vibration: {
          label: 'Vibration',
          value: '4.2 mm/s',
          normal: '0-3',
          unit: 'mm/s',
          reportedTimestamp: 'Feb 19, 2026, 10:28 AM',
        },
        pressure: {
          label: 'Pressure',
          value: '2.3 bar',
          normal: '2.5-3.2',
          unit: 'bar',
          reportedTimestamp: 'Feb 19, 2026, 10:28 AM',
        },
      },
    },
    {
      id: 'asset-3',
      name: 'Motor Drive',
      assetId: 'A233',
      model: 'MDM654321',
      make: 'Siemens',
      type: 'Motor',
      workOrderId: '',
      priority: 'Moderate',
      status: 'Online',
      statusLabel: 'Good',
      location: {
        workspace: 'Workspace East',
        zone: 'Zone 48',
        area: 'Finishing Zone',
      },
      image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80',
      healthScore: 73,
      alert: {
        type: 'warning',
        message: 'Estimated failure in 3 months',
        confidence: '85% confidence',
      },
      rul: {
        label: 'RUL',
        value: '1 Year 10 Months',
      },
      workOrders: {
        label: 'Work Orders',
        value: 2,
      },
      nextService: {
        label: 'Next Service',
        value: '20 Apr 2026',
      },
      failureProbability: {
        value: '25%',
        timeframe: 'with in 90 days',
      },
      recommendedAction: {
        title: 'Routine Inspection',
        description: 'Continue monitoring, next inspection in 30 days',
        severity: 'info',
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: '80 °C',
          normal: '20-60',
          unit: '°C',
          reportedTimestamp: 'Feb 19, 2026, 10:25 AM',
        },
        vibration: {
          label: 'Vibration',
          value: '4.2 mm/s',
          normal: '0-3',
          unit: 'mm/s',
          reportedTimestamp: 'Feb 19, 2026, 10:25 AM',
        },
        pressure: {
          label: 'Pressure',
          value: '2.9 bar',
          normal: '2.5-3.2',
          unit: 'bar',
          reportedTimestamp: 'Feb 19, 2026, 10:25 AM',
        },
      },
    },
  ],
  'assembly-zone': [
    {
      id: 'asset-4',
      name: 'Welding Robot',
      assetId: 'A234',
      model: 'WR-2200X',
      make: 'FANUC',
      type: 'Robotic Arm',
      workOrderId: 'WO-1340',
      priority: 'High',
      status: 'Online',
      statusLabel: 'Critical',
      location: {
        workspace: 'Workspace East',
        zone: 'Zone 22',
        area: 'Assembly Zone',
      },
      image: 'https://images.unsplash.com/photo-1565992441121-4367c2967103?w=800&q=80',
      healthScore: 55,
      alert: {
        type: 'error',
        message: 'Calibration drift detected',
        confidence: '92% confidence',
      },
      rul: {
        label: 'RUL',
        value: '1 Year 2 Months',
      },
      workOrders: {
        label: 'Work Orders',
        value: 3,
      },
      nextService: {
        label: 'Next Service',
        value: '22 Feb 2026',
      },
      failureProbability: {
        value: '78%',
        timeframe: 'with in 10 days',
      },
      recommendedAction: {
        title: 'Emergency Maintenance',
        description: 'Recalibrate robot arm to prevent assembly defects',
        severity: 'critical',
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: '72 °C',
          normal: '20-65',
          unit: '°C',
          reportedTimestamp: 'Feb 19, 2026, 10:30 AM',
        },
        vibration: {
          label: 'Vibration',
          value: '5.8 mm/s',
          normal: '0-3',
          unit: 'mm/s',
          reportedTimestamp: 'Feb 19, 2026, 10:30 AM',
        },
        pressure: {
          label: 'Pressure',
          value: '3.1 bar',
          normal: '2.5-3.2',
          unit: 'bar',
          reportedTimestamp: 'Feb 19, 2026, 10:30 AM',
        },
      },
    },
    {
      id: 'asset-5',
      name: 'Torque Station',
      assetId: 'A235',
      model: 'TS-500Pro',
      make: 'Atlas Copco',
      type: 'Torque System',
      workOrderId: '',
      priority: 'Moderate',
      status: 'Online',
      statusLabel: 'Warning',
      location: {
        workspace: 'Workspace East',
        zone: 'Zone 22',
        area: 'Assembly Zone',
      },
      image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80',
      healthScore: 76,
      alert: {
        type: 'warning',
        message: '15% torque variance detected',
        confidence: '88% confidence',
      },
      rul: {
        label: 'RUL',
        value: '2 Years 1 Month',
      },
      workOrders: {
        label: 'Work Orders',
        value: 1,
      },
      nextService: {
        label: 'Next Service',
        value: '10 Mar 2026',
      },
      failureProbability: {
        value: '35%',
        timeframe: 'with in 30 days',
      },
      recommendedAction: {
        title: 'Scheduled Maintenance',
        description: 'Replace torque sensor within 1 week',
        severity: 'warning',
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: '52 °C',
          normal: '20-60',
          unit: '°C',
          reportedTimestamp: 'Feb 19, 2026, 10:27 AM',
        },
        vibration: {
          label: 'Vibration',
          value: '2.1 mm/s',
          normal: '0-3',
          unit: 'mm/s',
          reportedTimestamp: 'Feb 19, 2026, 10:27 AM',
        },
        pressure: {
          label: 'Pressure',
          value: '2.7 bar',
          normal: '2.5-3.2',
          unit: 'bar',
          reportedTimestamp: 'Feb 19, 2026, 10:27 AM',
        },
      },
    },
    {
      id: 'asset-6',
      name: 'Assembly Conveyor',
      assetId: 'A236',
      model: 'AC-3000',
      make: 'Hytrol',
      type: 'Conveyor',
      workOrderId: '',
      priority: 'Low',
      status: 'Online',
      statusLabel: 'Good',
      location: {
        workspace: 'Workspace East',
        zone: 'Zone 22',
        area: 'Assembly Zone',
      },
      image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80',
      healthScore: 82,
      alert: {
        type: 'warning',
        message: 'Belt tension decreasing',
        confidence: '75% confidence',
      },
      rul: {
        label: 'RUL',
        value: '3 Years 2 Months',
      },
      workOrders: {
        label: 'Work Orders',
        value: 1,
      },
      nextService: {
        label: 'Next Service',
        value: '15 Apr 2026',
      },
      failureProbability: {
        value: '18%',
        timeframe: 'with in 60 days',
      },
      recommendedAction: {
        title: 'Routine Inspection',
        description: 'Order replacement belt and schedule downtime',
        severity: 'info',
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: '45 °C',
          normal: '20-60',
          unit: '°C',
          reportedTimestamp: 'Feb 19, 2026, 10:20 AM',
        },
        vibration: {
          label: 'Vibration',
          value: '1.8 mm/s',
          normal: '0-3',
          unit: 'mm/s',
          reportedTimestamp: 'Feb 19, 2026, 10:20 AM',
        },
        pressure: {
          label: 'Pressure',
          value: '2.9 bar',
          normal: '2.5-3.2',
          unit: 'bar',
          reportedTimestamp: 'Feb 19, 2026, 10:20 AM',
        },
      },
    },
  ],
  'packaging-zone': [
    {
      id: 'asset-7',
      name: 'Heat Sealer',
      assetId: 'A237',
      model: 'HS-800',
      make: 'Bosch Packaging',
      type: 'Sealing Unit',
      workOrderId: 'WO-1352',
      priority: 'High',
      status: 'Offline',
      statusLabel: 'Critical',
      location: {
        workspace: 'Workspace East',
        zone: 'Zone 15',
        area: 'Packaging Zone',
      },
      image: 'https://images.unsplash.com/photo-1565992441121-4367c2967103?w=800&q=80',
      healthScore: 48,
      alert: {
        type: 'error',
        message: 'Overheating detected - 15°C above normal',
        confidence: '95% confidence',
      },
      rul: {
        label: 'RUL',
        value: '1 Year 1 Month',
      },
      workOrders: {
        label: 'Work Orders',
        value: 4,
      },
      nextService: {
        label: 'Next Service',
        value: '20 Feb 2026',
      },
      failureProbability: {
        value: '92%',
        timeframe: 'with in 5 days',
      },
      recommendedAction: {
        title: 'Emergency Maintenance',
        description: 'Shut down and inspect heating element immediately',
        severity: 'critical',
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: '105 °C',
          normal: '60-90',
          unit: '°C',
          reportedTimestamp: 'Feb 19, 2026, 10:35 AM',
        },
        vibration: {
          label: 'Vibration',
          value: '3.5 mm/s',
          normal: '0-3',
          unit: 'mm/s',
          reportedTimestamp: 'Feb 19, 2026, 10:35 AM',
        },
        pressure: {
          label: 'Pressure',
          value: '3.4 bar',
          normal: '2.5-3.2',
          unit: 'bar',
          reportedTimestamp: 'Feb 19, 2026, 10:35 AM',
        },
      },
    },
    {
      id: 'asset-8',
      name: 'Label Printer',
      assetId: 'A238',
      model: 'LP-400X',
      make: 'Zebra Technologies',
      type: 'Printer',
      workOrderId: '',
      priority: 'Moderate',
      status: 'Online',
      statusLabel: 'Warning',
      location: {
        workspace: 'Workspace East',
        zone: 'Zone 15',
        area: 'Packaging Zone',
      },
      image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80',
      healthScore: 69,
      alert: {
        type: 'warning',
        message: '8% label misalignment in last batch',
        confidence: '82% confidence',
      },
      rul: {
        label: 'RUL',
        value: '1 Year 8 Months',
      },
      workOrders: {
        label: 'Work Orders',
        value: 2,
      },
      nextService: {
        label: 'Next Service',
        value: '05 Mar 2026',
      },
      failureProbability: {
        value: '40%',
        timeframe: 'with in 20 days',
      },
      recommendedAction: {
        title: 'Scheduled Maintenance',
        description: 'Realign print head within 2 days',
        severity: 'warning',
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: '55 °C',
          normal: '20-60',
          unit: '°C',
          reportedTimestamp: 'Feb 19, 2026, 10:22 AM',
        },
        vibration: {
          label: 'Vibration',
          value: '2.5 mm/s',
          normal: '0-3',
          unit: 'mm/s',
          reportedTimestamp: 'Feb 19, 2026, 10:22 AM',
        },
        pressure: {
          label: 'Pressure',
          value: '2.6 bar',
          normal: '2.5-3.2',
          unit: 'bar',
          reportedTimestamp: 'Feb 19, 2026, 10:22 AM',
        },
      },
    },
    {
      id: 'asset-9',
      name: 'Palletizer',
      assetId: 'A239',
      model: 'PL-1200',
      make: 'KUKA',
      type: 'Robotic Palletizer',
      workOrderId: '',
      priority: 'Moderate',
      status: 'Online',
      statusLabel: 'Warning',
      location: {
        workspace: 'Workspace East',
        zone: 'Zone 15',
        area: 'Packaging Zone',
      },
      image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80',
      healthScore: 65,
      alert: {
        type: 'warning',
        message: 'Hydraulic pressure declining gradually',
        confidence: '78% confidence',
      },
      rul: {
        label: 'RUL',
        value: '2 Years 5 Months',
      },
      workOrders: {
        label: 'Work Orders',
        value: 1,
      },
      nextService: {
        label: 'Next Service',
        value: '18 Mar 2026',
      },
      failureProbability: {
        value: '32%',
        timeframe: 'with in 30 days',
      },
      recommendedAction: {
        title: 'Scheduled Maintenance',
        description: 'Schedule hydraulic seal replacement',
        severity: 'warning',
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: '58 °C',
          normal: '20-60',
          unit: '°C',
          reportedTimestamp: 'Feb 19, 2026, 10:18 AM',
        },
        vibration: {
          label: 'Vibration',
          value: '3.8 mm/s',
          normal: '0-3',
          unit: 'mm/s',
          reportedTimestamp: 'Feb 19, 2026, 10:18 AM',
        },
        pressure: {
          label: 'Pressure',
          value: '2.2 bar',
          normal: '2.5-3.2',
          unit: 'bar',
          reportedTimestamp: 'Feb 19, 2026, 10:18 AM',
        },
      },
    },
  ],
};

// ─── Assigned Work Orders by Zone ───

const workOrdersByZone = {
  'finishing-zone': [
    {
      id: 'WO-2024-001',
      title: 'Emergency Bearing Replacement',
      priority: 'High',
      status: 'Scheduled',
      assignedTo: 'Lisa Cruise',
      location: 'Workspace East > Zone 48 > Finishing Zone',
      description: 'AI detected anomaly in sensor data. Replace worn bearing on primary circulation pump. Estimated failure in 2 weeks.',
      technician: 'Lisa Cruise',
      dueDate: '2026-02-05',
      cost: 2450,
      parts: 3,
    },
    {
      id: 'WO-2024-002',
      title: 'Oil Analysis - Pump A12',
      priority: 'High',
      status: 'Pending',
      assignedTo: 'Jane Cena',
      location: 'Workspace East > Zone 48 > Finishing Zone',
      description: 'Scheduled oil analysis to check for contamination and wear particles. Pump showing early signs of degradation.',
      technician: 'Jane Cena',
      dueDate: '2026-02-08',
      cost: 1200,
      parts: 2,
    },
    {
      id: 'WO-2024-003',
      title: 'Conveyor Belt Inspection',
      priority: 'Medium',
      status: 'Scheduled',
      assignedTo: 'Brad Sitt',
      location: 'Workspace East > Zone 48 > Finishing Zone',
      description: 'Routine conveyor belt inspection. Vibration patterns indicate potential misalignment in drive system.',
      technician: 'Brad Sitt',
      dueDate: '2026-02-12',
      cost: 850,
      parts: 1,
    },
    {
      id: 'WO-2024-004',
      title: 'Motor Vibration Analysis',
      priority: 'Medium',
      status: 'Completed',
      assignedTo: 'Tommy V',
      location: 'Workspace East > Zone 48 > Finishing Zone',
      description: 'Completed vibration analysis on main drive motor. Temperature readings trending upward, monitoring recommended.',
      technician: 'Tommy V',
      dueDate: '2026-01-28',
      cost: 980,
      parts: 0,
    },
    {
      id: 'WO-2024-005',
      title: 'Routine Lubrication Check',
      priority: 'Low',
      status: 'Completed',
      assignedTo: 'John Smith',
      location: 'Workspace East > Zone 48 > Finishing Zone',
      description: 'Standard lubrication check and top-up for all finishing zone equipment per maintenance schedule.',
      technician: 'John Smith',
      dueDate: '2026-01-25',
      cost: 320,
      parts: 4,
    },
  ],
  'assembly-zone': [
    {
      id: 'WO-2024-010',
      title: 'Welding Robot Recalibration',
      priority: 'High',
      status: 'Scheduled',
      assignedTo: 'Lisa Cruise',
      location: 'Workspace East > Zone 22 > Assembly Zone',
      description: 'Welding Robot W-22 calibration drifted 0.8mm beyond tolerance. Assembly defect rate increased 12% this week.',
      technician: 'Lisa Cruise',
      dueDate: '2026-02-20',
      cost: 3200,
      parts: 2,
    },
    {
      id: 'WO-2024-011',
      title: 'Torque Sensor Replacement',
      priority: 'Medium',
      status: 'Pending',
      assignedTo: 'Jane Cena',
      location: 'Workspace East > Zone 22 > Assembly Zone',
      description: 'Automated torque station T-05 showing inconsistent torque values. 15% variance detected in last 500 cycles.',
      technician: 'Jane Cena',
      dueDate: '2026-02-22',
      cost: 1800,
      parts: 3,
    },
    {
      id: 'WO-2024-012',
      title: 'Conveyor Belt Tension Adjustment',
      priority: 'Low',
      status: 'Scheduled',
      assignedTo: 'Brad Sitt',
      location: 'Workspace East > Zone 22 > Assembly Zone',
      description: 'Assembly conveyor AC-03 belt tension decreasing gradually. Adjustment needed to prevent slippage.',
      technician: 'Brad Sitt',
      dueDate: '2026-03-01',
      cost: 450,
      parts: 1,
    },
    {
      id: 'WO-2024-013',
      title: 'Assembly Line Alignment Check',
      priority: 'Medium',
      status: 'Pending',
      assignedTo: 'Tommy V',
      location: 'Workspace East > Zone 22 > Assembly Zone',
      description: 'Periodic alignment check for assembly line fixtures. Minor drift detected in station 3 positioning.',
      technician: 'Tommy V',
      dueDate: '2026-02-25',
      cost: 680,
      parts: 0,
    },
    {
      id: 'WO-2024-014',
      title: 'Pneumatic System Inspection',
      priority: 'Low',
      status: 'Completed',
      assignedTo: 'John Smith',
      location: 'Workspace East > Zone 22 > Assembly Zone',
      description: 'Routine inspection of pneumatic lines and fittings. Check for leaks and pressure drops across assembly stations.',
      technician: 'John Smith',
      dueDate: '2026-02-10',
      cost: 520,
      parts: 2,
    },
  ],
  'packaging-zone': [
    {
      id: 'WO-2024-020',
      title: 'Heat Sealer Element Replacement',
      priority: 'High',
      status: 'Scheduled',
      assignedTo: 'Brad Sitt',
      location: 'Workspace East > Zone 15 > Packaging Zone',
      description: 'Heat sealer HS-08 running 15°C above normal operating temperature. Risk of seal quality failure and potential fire hazard.',
      technician: 'Brad Sitt',
      dueDate: '2026-02-18',
      cost: 2800,
      parts: 4,
    },
    {
      id: 'WO-2024-021',
      title: 'Label Printer Head Realignment',
      priority: 'Medium',
      status: 'Pending',
      assignedTo: 'Lisa Cruise',
      location: 'Workspace East > Zone 15 > Packaging Zone',
      description: 'Label printer LP-02 misalignment detected. 8% of labels placed outside tolerance in last batch.',
      technician: 'Lisa Cruise',
      dueDate: '2026-02-21',
      cost: 950,
      parts: 1,
    },
    {
      id: 'WO-2024-022',
      title: 'Palletizer Hydraulic Seal Repair',
      priority: 'High',
      status: 'Scheduled',
      assignedTo: 'Jane Cena',
      location: 'Workspace East > Zone 15 > Packaging Zone',
      description: 'Palletizer P-01 hydraulic pressure showing gradual decline. Historical pattern suggests seal replacement needed.',
      technician: 'Jane Cena',
      dueDate: '2026-02-19',
      cost: 2100,
      parts: 3,
    },
    {
      id: 'WO-2024-023',
      title: 'Shrink Wrapper Calibration',
      priority: 'Low',
      status: 'Completed',
      assignedTo: 'Tommy V',
      location: 'Workspace East > Zone 15 > Packaging Zone',
      description: 'Completed calibration of shrink wrapper temperature and speed settings after film type change.',
      technician: 'Tommy V',
      dueDate: '2026-02-05',
      cost: 380,
      parts: 0,
    },
    {
      id: 'WO-2024-024',
      title: 'Carton Erector Maintenance',
      priority: 'Medium',
      status: 'Pending',
      assignedTo: 'John Smith',
      location: 'Workspace East > Zone 15 > Packaging Zone',
      description: 'Scheduled preventive maintenance for carton erector. Suction cups and folding arms need inspection.',
      technician: 'John Smith',
      dueDate: '2026-02-28',
      cost: 720,
      parts: 5,
    },
  ],
};

// ─── Requests by Zone ───

const requestsByZone = {
  'finishing-zone': [
    {
      id: 'RID-2024-134',
      title: 'Bearing failure',
      priority: 'High',
      location: 'Workspace East > Zone 48 > Finishing Zone',
      breadcrumb: 'Bearing failure - Pump A12 > RID-2024-134',
      description: 'AI detected anomaly in sensor data. Replace worn bearing on primary circulation pump. Estimated failure in 2 weeks.',
      asset: 'Pump-A12',
      assignedTo: 'John Smith',
      dueDate: '2026-02-05',
      createdDate: '2026-02-03',
      cost: 2450,
      parts: 3,
      partsList: [
        { name: 'Bearing Assembly', quantity: 1, cost: 1876 },
        { name: 'Seal Kit', quantity: 1, cost: 432 },
        { name: 'Lubricant', quantity: 1, cost: 142 },
      ],
    },
    {
      id: 'RID-2024-135',
      title: 'Pump A12 - Overheating',
      priority: 'High',
      location: 'Workspace East > Zone 48 > Finishing Zone',
      breadcrumb: 'Pump A12 - Overheating > RID-2024-135',
      description: 'Temperature readings 35°C above normal operating range. Cooling system inspection and repair required urgently.',
      asset: 'Pump-A12',
      assignedTo: 'Lisa Cruise',
      dueDate: '2026-02-06',
      createdDate: '2026-02-03',
      cost: 1850,
      parts: 2,
      partsList: [
        { name: 'Cooling Fan Assembly', quantity: 1, cost: 1250 },
        { name: 'Thermal Paste', quantity: 1, cost: 600 },
      ],
    },
    {
      id: 'RID-2024-136',
      title: 'Conveyor Belt B-07 Vibration',
      priority: 'Medium',
      location: 'Workspace East > Zone 48 > Finishing Zone',
      breadcrumb: 'Conveyor Belt B-07 Vibration > RID-2024-136',
      description: 'Increasing vibration patterns detected. Predictive model suggests 78% chance of failure within 30 days.',
      asset: 'Conveyor-B07',
      assignedTo: 'Brad Sitt',
      dueDate: '2026-02-15',
      createdDate: '2026-02-04',
      cost: 980,
      parts: 2,
      partsList: [
        { name: 'Drive Belt', quantity: 1, cost: 680 },
        { name: 'Tensioner Pulley', quantity: 1, cost: 300 },
      ],
    },
    {
      id: 'RID-2024-137',
      title: 'Motor M-15 Temperature Trending',
      priority: 'Medium',
      location: 'Workspace East > Zone 48 > Finishing Zone',
      breadcrumb: 'Motor M-15 Temperature Trending > RID-2024-137',
      description: 'Motor M-15 temperature readings are trending upward. Historical data suggests potential overheating within 45 days.',
      asset: 'Motor-M15',
      assignedTo: 'Tommy V',
      dueDate: '2026-02-20',
      createdDate: '2026-02-04',
      cost: 1500,
      parts: 3,
      partsList: [
        { name: 'Motor Winding Kit', quantity: 1, cost: 950 },
        { name: 'Cooling Fan', quantity: 1, cost: 350 },
        { name: 'Thermal Sensor', quantity: 1, cost: 200 },
      ],
    },
  ],
  'assembly-zone': [
    {
      id: 'RID-2024-140',
      title: 'Welding Robot Calibration Drift',
      priority: 'High',
      location: 'Workspace East > Zone 22 > Assembly Zone',
      breadcrumb: 'Welding Robot Calibration Drift > RID-2024-140',
      description: 'Welding Robot W-22 calibration drifted 0.8mm beyond tolerance. Assembly defect rate increased 12% this week.',
      asset: 'Welding Robot W-22',
      assignedTo: 'Lisa Cruise',
      dueDate: '2026-02-18',
      createdDate: '2026-02-10',
      cost: 3200,
      parts: 2,
      partsList: [
        { name: 'Calibration Module', quantity: 1, cost: 2400 },
        { name: 'Servo Motor', quantity: 1, cost: 800 },
      ],
    },
    {
      id: 'RID-2024-141',
      title: 'Torque Station T-05 Variance',
      priority: 'Medium',
      location: 'Workspace East > Zone 22 > Assembly Zone',
      breadcrumb: 'Torque Station T-05 Variance > RID-2024-141',
      description: 'Automated torque station T-05 showing inconsistent torque values. 15% variance detected in last 500 cycles.',
      asset: 'Torque-T05',
      assignedTo: 'Jane Cena',
      dueDate: '2026-02-22',
      createdDate: '2026-02-11',
      cost: 1800,
      parts: 3,
      partsList: [
        { name: 'Torque Sensor', quantity: 1, cost: 1100 },
        { name: 'Control Board', quantity: 1, cost: 500 },
        { name: 'Wiring Harness', quantity: 1, cost: 200 },
      ],
    },
    {
      id: 'RID-2024-142',
      title: 'Assembly Conveyor AC-03 Belt Tension',
      priority: 'Low',
      location: 'Workspace East > Zone 22 > Assembly Zone',
      breadcrumb: 'Assembly Conveyor AC-03 Belt Tension > RID-2024-142',
      description: 'Assembly conveyor AC-03 belt tension decreasing gradually. Predictive model suggests replacement needed within 60 days.',
      asset: 'Conveyor-AC03',
      assignedTo: 'Brad Sitt',
      dueDate: '2026-03-05',
      createdDate: '2026-02-12',
      cost: 650,
      parts: 2,
      partsList: [
        { name: 'Conveyor Belt', quantity: 1, cost: 450 },
        { name: 'Tension Spring Set', quantity: 1, cost: 200 },
      ],
    },
    {
      id: 'RID-2024-143',
      title: 'Pneumatic Cylinder Leak',
      priority: 'High',
      location: 'Workspace East > Zone 22 > Assembly Zone',
      breadcrumb: 'Pneumatic Cylinder Leak > RID-2024-143',
      description: 'Air leak detected in pneumatic clamping cylinder at station 5. Pressure drop causing inconsistent part holding force.',
      asset: 'Pneumatic-S05',
      assignedTo: 'John Smith',
      dueDate: '2026-02-19',
      createdDate: '2026-02-13',
      cost: 920,
      parts: 2,
      partsList: [
        { name: 'Cylinder Seal Kit', quantity: 1, cost: 620 },
        { name: 'Air Fitting Set', quantity: 1, cost: 300 },
      ],
    },
  ],
  'packaging-zone': [
    {
      id: 'RID-2024-150',
      title: 'Heat Sealer HS-08 Overheating',
      priority: 'High',
      location: 'Workspace East > Zone 15 > Packaging Zone',
      breadcrumb: 'Heat Sealer HS-08 Overheating > RID-2024-150',
      description: 'Heat sealer HS-08 running 15°C above normal operating temperature. Risk of seal quality failure and potential fire hazard.',
      asset: 'Heat Sealer HS-08',
      assignedTo: 'Brad Sitt',
      dueDate: '2026-02-17',
      createdDate: '2026-02-14',
      cost: 2800,
      parts: 4,
      partsList: [
        { name: 'Heating Element', quantity: 1, cost: 1500 },
        { name: 'Thermostat', quantity: 1, cost: 600 },
        { name: 'Insulation Kit', quantity: 1, cost: 400 },
        { name: 'Wiring Harness', quantity: 1, cost: 300 },
      ],
    },
    {
      id: 'RID-2024-151',
      title: 'Label Printer LP-02 Misalignment',
      priority: 'Medium',
      location: 'Workspace East > Zone 15 > Packaging Zone',
      breadcrumb: 'Label Printer LP-02 Misalignment > RID-2024-151',
      description: 'Label printer LP-02 misalignment detected. 8% of labels placed outside tolerance in last batch.',
      asset: 'Printer-LP02',
      assignedTo: 'Lisa Cruise',
      dueDate: '2026-02-21',
      createdDate: '2026-02-14',
      cost: 950,
      parts: 1,
      partsList: [
        { name: 'Print Head Assembly', quantity: 1, cost: 950 },
      ],
    },
    {
      id: 'RID-2024-152',
      title: 'Palletizer P-01 Hydraulic Decline',
      priority: 'High',
      location: 'Workspace East > Zone 15 > Packaging Zone',
      breadcrumb: 'Palletizer P-01 Hydraulic Decline > RID-2024-152',
      description: 'Palletizer P-01 hydraulic pressure showing gradual decline. Historical pattern suggests seal replacement needed within 30 days.',
      asset: 'Palletizer-P01',
      assignedTo: 'Jane Cena',
      dueDate: '2026-02-25',
      createdDate: '2026-02-15',
      cost: 2100,
      parts: 3,
      partsList: [
        { name: 'Hydraulic Seal Kit', quantity: 1, cost: 1200 },
        { name: 'Hydraulic Fluid', quantity: 2, cost: 450 },
        { name: 'Filter Element', quantity: 1, cost: 450 },
      ],
    },
    {
      id: 'RID-2024-153',
      title: 'Shrink Wrapper Film Tension',
      priority: 'Low',
      location: 'Workspace East > Zone 15 > Packaging Zone',
      breadcrumb: 'Shrink Wrapper Film Tension > RID-2024-153',
      description: 'Shrink wrapper showing inconsistent film tension causing wrinkled packaging on 5% of output.',
      asset: 'Shrink Wrapper SW-03',
      assignedTo: 'Tommy V',
      dueDate: '2026-03-01',
      createdDate: '2026-02-16',
      cost: 480,
      parts: 2,
      partsList: [
        { name: 'Tension Roller', quantity: 1, cost: 320 },
        { name: 'Guide Rail Set', quantity: 1, cost: 160 },
      ],
    },
  ],
};

// Helper function to get asset details by ID (searches across all zones)
export const getAssetById = (assetId) => {
  const allAssets = Object.values(assignedAssetsByZone).flat();
  return allAssets.find(asset => asset.id === assetId) || null;
};
